/**
 * Cross-tree bridge: exclusive choose-loyalty / RELEASE can clear the typed
 * applied chip without lifting CheckoutTypedPromoCodeBlock state.
 */

type ClearHandler = () => void;

let clearHandler: ClearHandler | null = null;

export function registerCustomerTypedPromoChipClear(handler: ClearHandler | null): void {
  clearHandler = handler;
}

export function clearCustomerTypedPromoChip(): void {
  clearHandler?.();
}
